import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from 'design';
import { Icon } from '../Icon';

const Layout = styled.div`
  justify-content: center;
  align-items: center;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    svg {
      fill: ${theme.color.neutral[800]};
      transition: fill ${theme.transition.icon};
    }

    &:hover {
      svg {
        fill: ${theme.color.neutral[400]};
      }
    }
  }
`;

const HeaderNotifications: React.FC = () => (
  <Layout>
    <Link to="/notifications">
      <Icon icon="Bell" width={17} height={17} />
    </Link>
  </Layout>
);

export default HeaderNotifications;
